export default __webpack_public_path__ + "static/media/header-bottom-fashion.f98574b2.png";